import { useEffect } from "react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useAuth } from "../auth/AuthProvider";
import { SignIn } from "../auth/SignIn";
import { ScopeGate } from "../auth/ScopeGate";

export const Route = createFileRoute("/onboarding")({ component: OnboardingRoute });

// A bookmarkable/directly-navigable entry point for the same wizard ScopeGate already shows
// in place for a brand-new owner (zero memberships, or a business with no site yet). This
// route does NOT duplicate that logic — it mounts the real ScopeGate, which renders the
// wizard for exactly the same phases it does inside "/". The only thing this route adds is
// somewhere useful to land if the session is already fully set up: straight back to the board.
function OnboardingRoute() {
  const auth = useAuth();

  if (auth.status === "loading") {
    return <div className="min-h-screen grid place-items-center text-slate-400" style={{ background: "#eef2f4" }}>Loading…</div>;
  }
  if (auth.status === "signedOut" || !auth.user) return <SignIn />;

  return (
    <ScopeGate uid={auth.user.uid}>
      {() => <AlreadyOnboarded />}
    </ScopeGate>
  );
}

// ScopeGate only calls this render prop once it has reached the "ready" phase — i.e. onboarding
// is already complete for this session. Bounce to the board rather than show anything here.
function AlreadyOnboarded() {
  const navigate = useNavigate();
  useEffect(() => { void navigate({ to: "/" }); }, [navigate]);
  return null;
}
